import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/web.dom-collections.for-each";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import i18n from '@pureartisan/simple-i18n';
import { Button } from 'reactstrap';
import { FaExternalLinkSquareAlt } from 'react-icons/fa';
import { CoreButton } from './../../../../core';
import NonInteractiveScale from './../../NonInteractiveScale/NonInteractiveScale';
import { CPAL_METRICS } from './../../../../../constants/metrics';
import { getRoundedValue, getMetric, getHashLeft, getQuintile } from './../../utils';
import useStore from './../../store';
/**
 * Returns popup contents for map feature mouseover
 */

var PopupContent = function PopupContent(_ref) {
  var props = _extends({}, _ref); // if (props.feature) {
  //   console.log('props.feature exists')
  //   console.log('props.feature, ', props.feature)
  // }
  // Generic state updates for store.
  // Accepts an object of values to update.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  });
  var interactionsMobile = useStore(function (state) {
    return state.interactionsMobile;
  });
  var breakpoint = useStore(function (state) {
    return state.breakpoint;
  }); // For tracking access school page events.

  var eventSchoolPage = useStore(function (state) {
    return state.eventSchoolPage;
  });
  var metrics = [];
  CPAL_METRICS.forEach(function (el) {
    if (el.tab_level === 0) {
      metrics.push(el.id);
    }
  });

  var setActiveQuintile = function setActiveQuintile(quintile) {
    var arr = [0, 0, 0, 0, 0];
    arr[quintile] = 1;
    return arr;
  };

  var navigateToSchool = function navigateToSchool(e) {
    e.preventDefault(); // console.log('navigateToSchool()')

    if (!!window) {
      // console.log('navigateToSchool() window exists')
      var href = window.location.origin + '/schools/' + props.feature.properties.SLN + '/'; // console.log('navigateToSchool() href is ', href)

      window.open(href, '_blank');
      setStoreValues({
        eventSchoolPage: eventSchoolPage + 1,
        accessedSchool: props.feature.properties.SLN
      });
    }
  };

  if (!!props.feature) {
    return /*#__PURE__*/React.createElement("div", {
      className: "popup-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "popup-school-name"
    }, /*#__PURE__*/React.createElement("h4", null, props.feature.properties.SCHOOLNAME), /*#__PURE__*/React.createElement("h5", null, i18n.translate('UI_MAP_TOOLTIP_FEEDER', {
      name: props.feature.properties.Feeder
    }))), metrics.map(function (metric) {
      var metricData = getMetric(metric, CPAL_METRICS);
      var label = i18n.translate(metricData.title);
      var value = String(props.feature.properties[metric]);
      var min = metricData.range[0];
      var max = metricData.range[1];
      var high_is_good = metricData.high_is_good;

      if (value.length > 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "popup-metric",
          key: "popup-metric-" + metric
        }, /*#__PURE__*/React.createElement("div", {
          className: "popup-metric-label"
        }, label, "\xA0\xA0", /*#__PURE__*/React.createElement("span", {
          className: "metric-value"
        }, !!value ? getRoundedValue(value, 0, false) : '')), /*#__PURE__*/React.createElement("div", {
          className: "popup-metric-scale"
        }, /*#__PURE__*/React.createElement(NonInteractiveScale, {
          metric: metric,
          showHash: false,
          quintiles: setActiveQuintile(getQuintile(value, min, max, high_is_good)),
          colors: metricData.colors,
          showMinMax: false,
          min: min,
          max: max
        })));
      } else {
        return '';
      }
    }), !!(breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md' || interactionsMobile) ? /*#__PURE__*/React.createElement(CoreButton, {
      id: "modal_access_school",
      className: "click-school-prompt",
      onClick: navigateToSchool,
      "aira-label": i18n.translate('UI_MAP_SCHOOL_ACCESS_LINK'),
      color: "light"
    }, /*#__PURE__*/React.createElement(FaExternalLinkSquareAlt, null), i18n.translate('UI_MAP_SCHOOL_ACCESS_LINK')) : /*#__PURE__*/React.createElement("p", {
      className: "click-school-prompt"
    }, i18n.translate('UI_MAP_CLICK_SCHOOL_PROMPT')));
  } else {
    setStoreValues({
      showMapModal: false
    });
    return null;
  }
};

export default PopupContent;